export const baseUrl = 'https://learn.baicizhan.com/api/mall/proxy'
export const homePageUrl = `${baseUrl}/homepage`
export const cartUrl = `${baseUrl}/cart`
export const detailUrl = `${baseUrl}/goodsdetail`
export const actUrl = `${baseUrl}/activity`
export const confirmUrl = `${baseUrl}/order`
export const wishUrl = `${baseUrl}/wishchallenge`
